module.exports = __webpack_public_path__ + "img/symbol_3.dbd469b7.png";